import IApiError from '../models/IApiError';

export default class ApiErrorStore {
    apiError : IApiError;

    constructor()
    {
        this.apiError = {
            statusHttpCode: 0,
            errorMessage: '',
            businessValidationMessage: ''
        }
    }

    setApiError = (error: any) => {
       if(error === undefined)
       {
            this.clearApiError()
            return;
       }

        this.apiError.statusHttpCode = error?.response?.status;
        this.apiError.errorMessage = error?.message;
        
        //if it's a 404 not found error, and a reason has been provided for 404 not found, then use the reason
        if(this.apiError.statusHttpCode == 404 && error?.response?.data?.detail != '')
            this.apiError.errorMessage = error?.response?.data?.detail;


        //if it's a business rule validation error, then set business validation message
        if(this.apiError.statusHttpCode == 409)
            this.apiError.businessValidationMessage = error?.response?.data?.detail;
    };

    clearApiError = () =>{
        this.apiError = {
            statusHttpCode: 0,
            errorMessage: '',
            businessValidationMessage: ''
        }
    }       
}
